import React, {FunctionComponent} from 'react';
import './DrawerHeader.less';
import {DrawerTitle} from 'elements/drawer-title/DrawerTitle';
import {DrawerDescription} from 'elements/drawer-description/DrawerDescription.tsx';

interface DrawerHeaderProps {
	title: string,
	description?: string | JSX.Element,
	bottomControl?: JSX.Element,
	onExternalLinkClick?: () => void
}

export const DrawerHeader: FunctionComponent<DrawerHeaderProps> = ({title, description, onExternalLinkClick, bottomControl}) => {
	return (<div className="drawer-header">
		<div className="drawer-header__container">
			{
				title && (
					<div className="drawer-header__title">
						<DrawerTitle text={title}/>
					</div>
				)
			}
			{
				description && (
					<div className="drawer-header__description">
						<DrawerDescription text={description} onExternalLinkClick={onExternalLinkClick}/>
					</div>
				)
			}
		</div>
		{
			bottomControl &&
			(
				<div className="drawer-header__bottom-control">{bottomControl}</div>
			)
		}
	</div>);
};
